import ReactPlayer from "react-player";
import Styles from "./VideoPlayer.module.css";
import { endpoints } from "../../utils/config";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { getToken } from "../../utils/utils";

export default function VideoPlayer({
  res_480,
  res_720,
  res_1080,
  onClose,
  name,
  id,
}) {
  const handleClose = () => {
    onClose();
  };
  // console.log(document.getElementsByTagName("video"));
  return (
    <div className={Styles.player_wrapper} style={{ margin: "0 auto" }}>
      <ReactPlayer
        url={
          endpoints.video +
          "/" +
          res_720 +
          "?" +
          new URLSearchParams({ id: id, jwt: getToken() })
        }
        controls={true}
        config={{ file: { attributes: { controlsList: "nodownload" } } }}
        onError={(err) => {
          console.log(err);
        }}
        playing={false}
        onContextMenu={(e) => e.preventDefault()}></ReactPlayer>
      <p className={Styles.video_title}>
        {name}
        <CloseRoundedIcon onClick={handleClose} style={{ cursor: "pointer" }} />
      </p>
    </div>
  );
}
